import {markRaw} from "vue";
import {ChannelManager} from "../channel/ChannelManager.ts";
import {SocketManager} from "../socket/SocketManager.ts";
import {RuleManager} from "../rule/RuleManager.ts";
import {PlaylistManager} from "../playlist/PlaylistManager.ts";
import {ConnectionSupervisor, SupervisorState} from "../socket/ConnectionSupervisor.ts";
import {CacheManager} from "../cache/CacheManager.ts";

let channelManagerRef: ChannelManager;
let ruleManagerRef: RuleManager;
let playlistManagerRef: PlaylistManager;

export const socketManager = new SocketManager({
    getChannelManager: () => channelManagerRef,
    getRuleManager: () => ruleManagerRef,
    getPlaylistManager: () => playlistManagerRef,
});

channelManagerRef = new ChannelManager();
ruleManagerRef = new RuleManager();
playlistManagerRef = new PlaylistManager();

export const channelManager = channelManagerRef;
export const ruleManager = ruleManagerRef;
export const playlistManager = playlistManagerRef;

// see docs/EXTRACTED_COMMENTS.md#c104
export const connectionSupervisor = markRaw(new ConnectionSupervisor({
    url: socketManager.getURL(),
    socketManager,
    getLayoutManager: () => socketManager.layoutManager,
    getChannelManager: () => channelManagerRef,
    getRuleManager: () => ruleManagerRef,
    getPlaylistManager: () => playlistManagerRef,
}));
socketManager.attachSupervisor(connectionSupervisor);

CacheManager.instance.configure({
    isLive: () => connectionSupervisor.state.value === SupervisorState.Live,
    snapshotProvider: () => {
        const layoutManager = socketManager.layoutManager;
        if (!layoutManager) return null;
        return layoutManager.composeSnapshotInput();
    },
    mediaPurgeHandler: (mediaUrls) => {
        if (typeof navigator === "undefined") return;
        const sw = navigator.serviceWorker?.controller;
        if (!sw) return;
        try {
            sw.postMessage({ type: "CACHE_SNAPSHOT_MEDIA_HINT", mediaUrls });
        } catch (e) {
            console.warn("[CacheManager] media-purge postMessage failed", e);
        }
    },
});
CacheManager.instance.startHeartbeat();
